<script setup lang="ts">
  import NotificationFilterModalBase from './NotificationFilterModalBase.vue';
  import { NotificationFilterFormData } from '../model';
  import { STATUS_OPTIONS } from '../model/filter.constants';

  defineProps<{
    currentFilters?: Partial<NotificationFilterFormData>;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'update:filter', filters: Partial<NotificationFilterFormData>): void;
    (e: 'clear-filters'): void;
  }>();

</script>

<template>
  <NotificationFilterModalBase
    :current-filters="currentFilters"
    :default-custom-periodicity="null"
    :status-options="STATUS_OPTIONS"
    :show-created-by="false"
    grid-border-class="border-b border-gray-02"
    date-section-class="py-6"
    :show-date-section-title="false"
    @close="emit('close')"
    @update:filter="emit('update:filter', $event)"
    @clear-filters="emit('clear-filters')"
  />
</template>
